import { AuthService, User } from '@skinsoft/auth';
import { Cache, DataStore, DataStoreOptions } from '@skinsoft/data-store';
import { Proxy } from '@skinsoft/network';
import { set } from 'lodash';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

interface EntityDataStoreOptions extends DataStoreOptions {
    userScope?: boolean;
}

export abstract class EntityDataStore<T extends { id: string } = any, U = any, S = T> extends DataStore<T, S> {
    public readonly featuredStates: U[] = [];
    public readonly historyStates: U[] = [];
    public readonly sortFields: string[] = [];
    public readonly entityName: string;

    constructor(entityName: string, typesForSearch?: string[], proxy?: Proxy, cache?: Cache<T>) {
        super(
            `/${entityName}`,
            typesForSearch,
            response => (response._embedded ? response._embedded[entityName] : []), // for getAll
            proxy,
            cache,
        );
        this.entityName = entityName;
    }

    public fetchAll(options: EntityDataStoreOptions = {}): Observable<T[]> {
        const { userScope, ...otherOptions } = options;

        if (!userScope) {
            return super.fetchAll(otherOptions);
        }

        return AuthService.getInstance().user$.pipe(
            filter(u => u !== null),
            switchMap(user =>
                super.fetchAll(set(otherOptions, 'query.affectedUser', (user as User).id)),
            ),
        );
    }
}
